import { render, staticRenderFns } from "./EscalaCaidas.vue?vue&type=template&id=48fa781d&"
import script from "./EscalaCaidas.vue?vue&type=script&lang=js&"
export * from "./EscalaCaidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports